import s from "./tokens.json.mjs";
import { computeFieldByPath as i } from "./utils8.mjs";
const y = s.brand, d = (a) => {
  const t = y.typography, e = {};
  for (const o in t) {
    o === "Deprecated" && (e["Deprecated.caption"] = t.Deprecated.caption.value);
    for (const n in t[o]) {
      const p = {};
      for (const r in t[o][n].value) {
        const c = r === "textCase" ? "textTransform" : r;
        p[c] = i(
          a,
          // @ts-expect-error and here
          t[o][n].value[r]
        );
      }
      e[`${o}.${n}`] = p;
    }
  }
  return e;
};
export {
  d as compileTypography
};
//# sourceMappingURL=compileTypography.mjs.map
